import React, { useState, useEffect } from "react";
import styled from "styled-components";

import { MdOutlineFileDownload } from "react-icons/md";
// import AboutExp from "./AboutExp";

function AboutnewExp() {
  const [experience, setExperience] = useState({
    years: 0,
    months: 0,
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    const calculateExperience = () => {
      const startDate = new Date("2022-05-01T00:00:00"); // Replace with your start date
      const currentDate = new Date();
      const diff = currentDate - startDate;

      const years = currentDate.getFullYear() - startDate.getFullYear();
      const months = currentDate.getMonth() - startDate.getMonth();
      const days = Math.floor(diff / (1000 * 60 * 60 * 24)) % 30;
      const hours = currentDate.getHours();
      const minutes = currentDate.getMinutes();
      const seconds = currentDate.getSeconds();

      setExperience({
        years,
        months: months >= 0 ? months : 12 + months,
        days,
        hours,
        minutes,
        seconds,
      });
    };

    // Calculate experience initially
    calculateExperience();

    // Update experience every second
    const interval = setInterval(calculateExperience, 1000);

    return () => clearInterval(interval);
  }, []);




  // Experiance only
  const Detail =[
    {
      url:"#timeline",
      experiance:`${experience.years}`,
      topic:"YEAR OF EXPERIANCE"
    },
    {
      url:"/project",
      experiance:"5+",
      topic:"PROJECT COMPLETED"
    },
    

  ]

  const NewExpStyle = styled.section`
      .flip-container {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 50px;
  perspective: 1000px;
}

.flip {
  position: absolute;
  width: 100%;
  height: 100%;
  background: #333;
  color: #fff;
  line-height: 50px;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  border-radius: 5px;
  transform-origin: bottom;
  transform: rotateX(0deg);
  animation: flip-animation 1s infinite;
}

@keyframes flip-animation {
  0% {
    transform: rotateX(0deg);
  }
  50% {
    transform: rotateX(90deg);
  }
  100% {
    transform: rotateX(0deg);
  }
}
.newExpbox
{
    display:flex;
    justify-content:center;
    align-items:center;
 
    flex-wrap:wrap;
  
}
.NexExpInd 
{
    width:150px;
    height:100px;
    margin:10px;
   

    
    border: 2px solid #00A1E6;
}
.NewIndBox
{
    background:#00A1E6;
    width:100%;
    height:100%;
    display:flex;
    align-items:center;
    justify-content:center;
    margin: 10px 0px 0px 10px;
    color: white;
    font-size:18px;
}
.NewIndBox span
{
    font-size:42px; 
    margin-right:5px;
    
}
.main-exp-box
{
  display:flex;
  align-items:center;
  justify-content:center;
  flex-direction:column;
  margin:50px 0px;
}
@media only screen and (max-width: 767px) {

    .NexExpInd 
{
    width:80px;
    height:50px;

}
.NewIndBox
{
    font-size:16px;

}
.NewIndBox span
{
    font-size:20px; 
    margin-right:5px;
    
}

  
      `;

  return (
    <NewExpStyle>
      <>
        <div className="about-section">
          <div className="about-div">
            <p className="intro">
              As a highly skilled frontend developer, I am dedicated to crafting
              captivating user experiences through the seamless fusion of design
              and functionality. With an unwavering commitment to innovation, I
              strive to bring visions to life, pushing the boundaries of web
              development to create immersive digital journeys that captivate,
              engage, and inspire.
            </p>
            <div className="resumeBox">
              <a
                href="Abhinaw Resume 2024.pdf"
                className="resume"
                download="Abhinaw Resume.pdf"
              >
                Download CV
                <MdOutlineFileDownload />
              </a>
            </div>
          </div>
          <div className="experiance">
            ${'' /* <AboutExp experience={experience.years} /> */}


            {
            Detail.map((item,i)=>
            
            <a href={item.url}>
               <div className="exp-div"  key={i}>
               <h1 className="name">{item.experiance}</h1>
               <h2 className="exp-topic">{item.topic}</h2>
            </div>
            </a>
            
            
            )
        }
          </div>
        </div>

        <div className="main-exp-box">

        <h4 className="name">Learning Every Seconds</h4>



          <div className="newExpbox">
            <div className="NexExpInd">
              {" "}
              <div className="NewIndBox">
                {" "}
                <span>{experience.years} </span> Years
              </div>{" "}
            </div>
            <div className="NexExpInd">
              <div className="NewIndBox">
                {" "}
                <span>{experience.months}</span> Months
              </div>
            </div>
            <div className="NexExpInd">
              <div className="NewIndBox">
                {" "}
                <span>{experience.days}</span> Days
              </div>
            </div>
            <div className="NexExpInd">
              <div className="NewIndBox">
                {" "}
                <span>{experience.hours}</span> Hours
              </div>
            </div>
            <div className="NexExpInd">
              <div className="NewIndBox">
                {" "}
                <span>{experience.minutes}</span> Mins
              </div>
            </div>
            <div className="flip-container NexExpInd">
              <div className="flip NewIndBox">
                <span>{experience.seconds}</span> Sec
              </div>
            </div>
          </div>
        </div>
      </>
    </NewExpStyle>
  );
}

export default AboutnewExp;
